import React from 'react'
import { Link } from 'react-router-dom'

/**
 * The one back control used on every screen.
 *
 * Screens used to have four different ones — a yellow "Back" in the wizard
 * header, a yellow "Application" on the payment pages, an outlined link on the
 * admit card and a grey button on the practice result — and several had none.
 * This gives them the same icon, shape, position (top-left, above the content)
 * and wording: "Back to <where it goes>".
 *
 * `light` is for white surfaces (inside a card, the admit card page); without
 * it the button is styled for the portal's dark page background.
 */
const DESTINATIONS = {
  '/': 'Home',
  '/application': 'Dashboard',
  '/application-form': 'Application Form',
  '/step2': 'Upload Documents',
  '/question-bank': 'Question Bank',
  '/subject-page': 'Subjects',
}

const BackButton = ({ to, label, light = false }) => {
  const name = label || DESTINATIONS[to.split('?')[0]] || 'previous page'
  return (
    <Link to={to} className={`ui_back${light ? ' ui_back_light' : ''}`}>
      <i className='fa fa-arrow-left' aria-hidden='true'></i>
      Back to {name}
    </Link>
  )
}

export default BackButton
